export default function SectionAbout() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-information-fill text-secondary-400 text-xs"></i></span>
            <span className="text-xs text-secondary-400 font-medium whitespace-nowrap">关于我们</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-4">关于夜猫</h2>
          <div className="p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/70">
            <div className="flex items-center justify-center mb-5">
              <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/10">
                <i className="ri-movie-2-fill text-primary-400 text-2xl"></i>
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed text-left">
              夜猫影院成立于 2024 年，是一个专为深夜观影爱好者打造的电影大全免费平台。我们相信，深夜是最好的观影时光——世界安静下来，屏幕亮起，故事开始。
            </p>
            <p className="text-sm text-foreground-300 leading-relaxed text-left mt-3">
              我们的编辑团队由一群热爱电影的夜猫子组成，每天精选最新电影在线看资源，覆盖动作、悬疑、科幻、喜剧、爱情、动画、纪录、恐怖等全类型影片。无论是热门电影推荐还是冷门佳作，我们都用心筛选，确保每一部推荐都值得你在深夜投入宝贵的两小时。
            </p>
            <p className="text-sm text-foreground-300 leading-relaxed text-left mt-3">
              除了高清电影播放，我们还提供深度影评、专题策划和影迷社区交流。夜猫影院不只是一个看电影的地方，更是深夜影迷的精神角落。我们持续优化播放体验，坚持完全免费，让每一个深夜都有好片相伴。
            </p>
            <div className="flex flex-wrap justify-center gap-4 mt-6 pt-5 border-t border-background-200/50">
              {[
                { num: '5000+', label: '影片资源' },
                { num: '300万+', label: '月活影迷' },
                { num: '99.7%', label: '播放成功率' },
              ].map((s) => (
                <div key={s.label} className="text-center">
                  <p className="text-lg font-bold text-primary-400 font-heading">{s.num}</p>
                  <p className="text-[11px] text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}